var blackInkRgb = '25, 25, 25'; // NeutralColors.Ink

export var BOX_SHADOWS = {
  small: "0 2px 4px 0 rgba(".concat(blackInkRgb, ", 0.08)"),
  medium: "0 2px 5px 0.5px rgba(".concat(blackInkRgb, ", 0.12)"),
  large: "0 3px 6px 0.5px rgba(".concat(blackInkRgb, ", 0.18)")
};